import { CardProviderBadge } from '@/components/card-provider-icons/card-provider-badge';
import type { CardProviderBadgeName } from '@/components/card-provider-icons/card-provider-badge-theme';
import type { CardProvider } from '@/lib/format-card';
import { cn } from '@/lib/utils';

const BADGE_PROVIDERS = new Set<CardProvider>(['HUMO', 'UZCARD', 'VISA']);

function isBadgeProvider(provider: CardProvider): provider is CardProviderBadgeName {
	return BADGE_PROVIDERS.has(provider);
}

interface CardProviderIconProps {
	provider: CardProvider | null | undefined;
	className?: string;
}

export default function CardProviderIcon({ provider, className }: CardProviderIconProps) {
	if (!provider || !isBadgeProvider(provider)) return null;

	return (
		<span title={provider} className='inline-flex shrink-0'>
			<CardProviderBadge provider={provider} className={cn('h-[16px] w-auto shrink-0', className)} />
		</span>
	);
}
